
import { useImperativeHandle, forwardRef, useState,} from "react"
import styles from './index.module.scss'
import { Modal, } from 'antd';
import { CloseOutlined } from '@ant-design/icons';


const MiddleEventPopup = forwardRef((props, ref) => {

    const [open, setOpen] = useState(false)
    const [popupData, setPopupData] = useState()
    const [callback, setCallback] = useState(() => { })

    useImperativeHandle(ref, () => ({
        handleClick
    }))

      const handleClick = (popup, onClose) => {
        setPopupData(popup)
        setCallback(() => onClose)
        setOpen(true)
    }
    const cancleClick = () => {
        if(callback) callback()
        setOpen(false)
    }


    return (
        <>
            <Modal
                open={open}
                footer={null}
                maskClosable
                width="480px"
                destroyOnHidden
                onCancel={cancleClick}
                centered
                wrapClassName={styles.MiddleEventPopupBox}
                closeIcon={<span className={styles.modalcloseIcon}><CloseOutlined /></span>}
            >
                <div
                onClick={() => {props.popupClick(popupData); cancleClick()}}
                className={styles.MiddleEventPopup}>
                    <img src={popupData?.popupImage} alt="" />
                </div>
            </Modal>
        </>
    )
})

export default MiddleEventPopup